import React from 'react';
import './ModalSendforvalidation.css';  // Import the above CSS
 
const SendforValidationModal = ({ show, handleClose, children }) => {
  if (!show) {
    return null;  // Do not render if show is false
  }
 
  return (
    <div className="modal-overlay" >
      <div className="modalcontent" onClick={(e) => e.stopPropagation()}>        
        <div className="modal-body">
          {children} {/* This is where the modal content will be displayed */}
        </div>
        <button className="modal-close" onClick={handleClose}>OK</button>
      </div>
    </div>
  );
};
 
export default SendforValidationModal;